/* global axios */
import ApiClient from './ApiClient';

class GgSupportStateAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  current(conversationId, ticketId, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support_states/current`,
      { ticket_id: ticketId },
      { signal }
    );
  }

  confirm(conversationId, command) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support_states/confirm`,
      command
    );
  }

  operation(conversationId, operationId, { signal } = {}) {
    return axios.get(
      `${this.url}/${conversationId}/gg_support_states/operation`,
      {
        params: { operation_id: operationId },
        signal,
      }
    );
  }

  resume(conversationId, operationId) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support_states/resume`,
      { operation_id: operationId }
    );
  }
}

export default new GgSupportStateAPI();
